import { Form } from 'antd';

import { getKey } from '../../helpers/common.helpers';
import './BaseFormFieldWrapper.scss';
import { Trans } from 'react-i18next';

export const BaseFormFieldWrapper = (Component) => (props) => {
  const { field, form, label, onChange, ...rest } = props;

  const touched = getKey(form.touched, field.name);
  const error = getKey(form.errors, field.name);

  const touchedError = error && touched;

  const onBlur = () => form.setFieldTouched(field.name, true);

  const handleChange = (value) => {
    form.setFieldValue(field.name, value);

    if (onChange) {
      onChange(value, field.name);
    }
  };

  const errorMessage = touchedError && error ? (
    <Trans
      i18nKey={error.key ?? error}
      defaults={error.key ?? error}
      values={error.options ?? {}}
      components={{
        strong: <strong />,
        em: <em />,
      }}
    />
  ) : null;

  return (
    <div className="field-container">
      <Form.Item
        layout='vertical'
        label={label}
        help={errorMessage}
        validateStatus={touchedError ? 'error' : 'success'}
      >
        <Component {...field} {...rest} onBlur={onBlur} handleChange={handleChange} />
      </Form.Item>
    </div>
  );
};

export default BaseFormFieldWrapper;
